module.exports = __webpack_public_path__ + "assets/img/url-tab.23b84758.svg";